import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Phone, Instagram, Facebook, FileText, Lock, Quote } from "lucide-react";
import { useLang } from "../LanguageContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="bg-forest-deep text-cream-100 mt-24" data-testid="site-footer">
      <div className="container-page py-16 grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <img
              src="/logo.png"
              alt=""
              className="w-10 h-10 rounded-full bg-cream-50 object-cover shrink-0"
            />
            <div className="font-heading text-base text-cream-50 font-semibold">
              École Pleine Nature
            </div>
          </div>
          <p className="text-sm text-cream-100/70 leading-relaxed max-w-sm">
            {t("common.footer_subtitle")}
          </p>
        </div>

        <div className="space-y-3 text-sm">
          <h4 className="font-heading text-cream-50 text-base mb-2">{t("common.footer_contact")}</h4>
          <a
            href="mailto:contact@ecolepleinenature.org"
            className="flex items-center gap-2 text-cream-100/80 hover:text-cream-50"
            data-testid="footer-email"
          >
            <Mail size={15} /> contact@ecolepleinenature.org
          </a>
          <div className="flex items-start gap-2 text-cream-100/80">
            <MapPin size={15} className="mt-0.5" />
            <span>
              {t("pratique.address_l1")}<br />{t("pratique.address_l2")}<br />{t("pratique.address_l3")}
            </span>
          </div>
          <div className="flex items-center gap-2 text-cream-100/80">
            <Phone size={15} /> <a href="tel:+33980615298" className="hover:text-cream-50">{t("pratique.phone")}</a>
          </div>
          <div className="flex items-center gap-3 pt-2">
            <a href="#" className="text-cream-100/70 hover:text-cream-50" aria-label="Instagram"><Instagram size={18} /></a>
            <a href="#" className="text-cream-100/70 hover:text-cream-50" aria-label="Facebook"><Facebook size={18} /></a>
          </div>
        </div>

        <div className="space-y-2 text-sm">
          <h4 className="font-heading text-cream-50 text-base mb-2">{t("common.footer_resources")}</h4>
          <a
            href="https://docs.google.com/document/d/14x6_hkFcM2-UPezSFhN5qaMnDMOJ_ev2bpkK0IhN4Gs/view"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-cream-100/80 hover:text-cream-50"
            data-testid="footer-projet-doc"
          >
            <FileText size={15} /> {t("common.footer_school_doc")}
          </a>
          <Link to="/temoignages" className="flex items-center gap-2 text-cream-100/80 hover:text-cream-50" data-testid="footer-testimonials">
            <Quote size={15} /> {t("common.footer_testimonials")}
          </Link>
          <Link to="/espace-membres" className="flex items-center gap-2 text-cream-100/80 hover:text-cream-50" data-testid="footer-members">
            <Lock size={15} /> {t("nav.members")}
          </Link>
          <Link to="/mentions-legales" className="block text-cream-100/80 hover:text-cream-50" data-testid="footer-mentions">
            {t("common.mentions")}
          </Link>
        </div>
      </div>
      <div className="border-t border-cream-100/10">
        <div className="container-page py-5 text-xs text-cream-100/50 flex flex-wrap items-center justify-between gap-2">
          <span>© {new Date().getFullYear()} École Pleine Nature — {t("common.footer_copy")}</span>
          <span>{t("common.footer_made")}</span>
        </div>
      </div>
    </footer>
  );
}
